<div class="inflate" (resize)="onResize($event)">
    <ng-content></ng-content>
</div>
